import { FC, useEffect, useState, useRef, useMemo } from "react";
import { Col, Collapse, Row, Modal, Button, Space, DatePicker, Tooltip, Spin } from "antd";
import { EditOutlined } from "@ant-design/icons";
import moment from "moment";
import { isEmpty, cloneDeep } from "lodash";
import { PdfModal, PdfProvider } from "../pdf";
import { CanEdit } from "@components/accessLevel";

import { appInsights, reactPlugin, withAITracking } from "../../../../appInsights";
import CustomTooltip from "@pages/tool-tip";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import { centricClientCheck, formatDisplayDate, formatPhoneNumber } from "@utils/helpers";
import Highlighter from "react-highlight-words";
import { getProgressColorCode } from "@pages/utils/utils";
import { dateFormatConfig } from "@utils/constants";
import { getClientName } from "@utils/helpers";
import membersService from "@services/members.service";
import memberDetailsService from "@services/memberDetails.service";

// import "./endoflife.scss";
import MemberItems from "@pages/member-details/items";
import UpdateTextWithDropdown, { TextField } from "./update-text-with-dropdown/UpdateTextWithDropdown";
import UtilizationReport, { PdfOpenButon, UtilizationReportProvider } from "../utilizationReviewReport/utilizationReport";
import { getDiffFromToday } from "@pages/utils/utils";
import { usePatientProfileStore } from "@stores/patientProfileStore";
import "./memberDetails.scss";
// import arrowMark from "../../../../assets/icon_config";
import Icon from "@assets/icon_config";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import CurrentCM from "./components/currentCM/CurrentCM";
import { useMemberDetailsStore } from "@stores/memberDetailsStore";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../../constants/constants";

interface IMemberPersonalInfo {
  pinChangeHandler: any;
  pinCardIds: any;
  activeKey: any;
  setActivePanels: any;
}

enum AttributeKeys {
  PCPNAMELIST = "PcpNameLst",
  OFFICENAMELIST = "OfficeNameLst",
}

const MemberDetails: FC<IMemberPersonalInfo> = (props) => {
  const dataCardId = "37";

  const [activeCardPanel, setActiveCardPanel] = useState<any[]>(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
  const memberDetailsAttributedPcpNameLetest = usePatientProfileStore((state) => state.memberDetailsAttributedPcpNameLetest);
  const setMemberDetailsAttributedPcpNameLetest = usePatientProfileStore((state) => state.setMemberDetailsAttributedPcpNameLetest);
  const memberDetailsAttributedOfficeNameLetest = usePatientProfileStore((state) => state.memberDetailsAttributedOfficeNameLetest);
  const setMemberDetailsAttributedOfficeNameLetest = usePatientProfileStore((state) => state.setMemberDetailsAttributedOfficeNameLetest);
  const [patientStatus, setpatientStatus] = useState<string>(membersService?.getCurrentMember?.patient_status || "");
  const [memberData, setMemberData, memberDetailLoader, setMemberDetailLoader] = useMemberDetailsStore((state) => [
    state.memberData,
    state.setMemberData,
    state.memberDetailLoader,
    state.setMemberDetailLoader,
  ]);
  const [attributedPCPPhone, setattributedPCPPhone] = useState<string>(memberData?.attributed_pcp_phone_number || "");

  const { Panel } = Collapse;
  const isCentric = centricClientCheck();

  useEffect(() => {
    console.log("MemberDetails.useEffect1");
    appInsights.trackPageView({ name: "Profile" });
  }, []);

  useEffect(() => {
    setActiveCardPanel(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
    // if(!memberData && props?.activeKey?.includes("37")) {
    //   getMemberDetails(["1"]);
    // }
  }, [props?.activeKey]);

  const onCollapseChange = () => {
    if (activeCardPanel.length > 0) {
      props.setActivePanels(cloneDeep(props?.activeKey)?.filter((item: any) => item !== dataCardId));
    } else {
      // if(!memberData) {
      //   getMemberDetails(["1"]);
      // }
      props.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
    }
  };

  const patientID = useMemo(() => {
    const cMember = membersService?.getCurrentMember;
    return cMember?.patient_id;
  }, [membersService?.getCurrentMember?.patient_id]);

  const getMemberDetails = (panelExpanded: any) => {
    if (panelExpanded?.length > 0) {
      setMemberDetailLoader(true);
      memberDetailsService.getMemberDetailsRecords(patientID).subscribe({
        next: (response) => {
          setMemberDetailLoader(false);
          setMemberData(response?.data?.data?.memberDetails);
        },
        error: (e) => {
          console.log(e);
          setMemberDetailLoader(false);
          setMemberData(null);
        },
      });
    } else console.log("Data card is available, no API call");
  };

  // useEffect(() => {
  //   if(memberData?.patientId !== patientID) {
  //     getMemberDetails(['1']);
  //   }
  // }, [patientID]);

  const evalAge = (dob: any) => {
    return <span className="memberAgeInYears">{moment(dob).isValid() ? `(${moment().diff(moment(dob), "years")} Yrs)` : null}</span>;
  };

  const getHeading = (headerValue: any) => (
    <>
      <Row>
        <span>{headerValue}</span>
        <CustomTooltip toolTipvalue={headerValue} children={<span style={{ margin: "8px" }} className="icon icon-info clr-lightGrayColor"></span>} />
      </Row>
    </>
  );

  const genExtra = (id: any) => (
    <div
      className="center-align-content"
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      {(getClientName() === "Tredence Dev" || getClientName() === "Tredence" || getClientName() === "Mycare") && (
        <div className="center-align-content claims-history-btn mr--20">
          <PdfProvider title="utilization-review-report">
            <UtilizationReportProvider>
              <PdfOpenButon title="Utilization Review Report" />
              <PdfModal title="Utilization Review Report">
                <UtilizationReport patientId={memberData?.patientId} />
              </PdfModal>
            </UtilizationReportProvider>
          </PdfProvider>
        </div>
      )}
      <div>
        <PinUnpin marginRight={"16px"} dataCardId={id} changeHandler={props?.pinChangeHandler} pinCardIds={props.pinCardIds} />
      </div>
    </div>
  );
  const highlighterColorCoded = (item: any, text: any, record: any, searchWord: any) => {
    return (
      <span style={{ color: `${getProgressColorCode(item)}` }}>
        <Tooltip placement="topLeft" title={text ? text.toString() : ""}>
          <Highlighter highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }} searchWords={[searchWord]} autoEscape textToHighlight={text ? `${text.toString()}` : "123"} />
        </Tooltip>
      </span>
    );
  };

  useEffect(() => {
    setattributedPCPPhone(memberData?.attributed_pcp_phone_number);
  }, [memberData?.attributed_pcp_phone_number, memberData?.memberId]);

  useEffect(() => {
    let patientStatus = memberData?.date_of_death && memberData?.date_of_death !== "--" ? "Deceased" : membersService?.getCurrentMember?.patient_status;
    setpatientStatus(patientStatus);
  }, [membersService?.getCurrentMember?.patient_status, memberData?.memberId, memberData?.date_of_death]);

  return (
    <Collapse accordion={true} activeKey={activeCardPanel} expandIconPosition="right" bordered={false} onChange={onCollapseChange}>
      <Panel className="title" header={getHeading("Members Details")} key="1" extra={genExtra(dataCardId)} style={{ marginBottom: "8px" }}>
        {/* <Card> */}
        {memberDetailLoader ? (
          <Spin spinning={memberDetailLoader} indicator={<HealthemSpinner size={50} />}></Spin>
        ) : memberData ? (
          <>
            <Row>
              {/* <Col className="title overview-title" span={24}> </Col> */}
              <Col span={12}>
                <MemberItems left={10} right={14} name={isCentric ? "Health Plan ID" : "Payer ID"} value={memberData?.memberId && memberData?.memberId.trim() !== "" ? memberData?.memberId : "--"} />
              </Col>
              {!isCentric && (
                <Col span={12}>
                  <MemberItems
                    left={11}
                    right={13}
                    name={
                      <>
                        <>Record ID</>
                      </>
                    }
                    value={memberData?.recordId ? memberData?.recordId : "--"}
                  />
                </Col>
              )}
              <Col span={12}>
                <MemberItems left={10} right={14} name={isCentric ? "Health Plan" : "Insurance"} value={memberData?.payorName && memberData?.payorName.trim() !== "" ? memberData?.payorName : ""} />
              </Col>
              <Col span={12}>
                <MemberItems
                  left={11}
                  right={13}
                  name={
                    <>
                      <>Risk Level </>
                      <p>Current Month</p>
                    </>
                  }
                  rightClass="d-flex"
                  value={
                    <>
                      {memberData?.risk_level === null ? "--" : highlighterColorCoded(memberData?.risk_category_flag, memberData?.risk_level, "", "")}{" "}
                      {memberData?.mycare_category_comparision === "Increase" ? (
                        <span style={{ paddingLeft: "5px" }}>
                          <Icon name="redUpArrow" />
                        </span>
                      ) : memberData?.mycare_category_comparision === "Decrease" ? (
                        <span style={{ paddingLeft: "5px" }}>
                          <Icon name="greenDownArrow" />
                        </span>
                      ) : null}
                    </>
                  }
                />
              </Col>
              <Col span={5} className="f16" style={{ color: "#5e6c84" }}>
                <p className={`member-key`}>
                  {isCentric ? "Health Plan" : "Insurance"}
                  <p>Start Date</p>{" "}
                </p>
              </Col>
              <Col span={7}>
                <p>
                  <span className="f16 w500 clr-n125">{`${
                    memberData?.planStartDate && memberData?.planStartDate !== "01-01-1900 00:00:00" ? formatDisplayDate(memberData?.planStartDate) : "--"
                  } `}</span>
                  <span className="f16 clr-n3 w500">
                    {memberData?.planStartDate && memberData?.planStartDate !== "01-01-1900 00:00:00" && (
                      <>
                        ({getDiffFromToday(moment(), moment(memberData?.planStartDate, "DD-MM-YYYY HH:mm:ss"), "Y-M")}
                        back)
                      </>
                    )}
                  </span>
                </p>
              </Col>

              <Col span={12}>
                <MemberItems
                  left={11}
                  right={13}
                  name={
                    <>
                      <>Risk Level </>
                      <p>Previous Month</p>
                    </>
                  }
                  value={memberData?.prev_risk_level === null ? "--" : highlighterColorCoded(memberData?.prev_risk_category_flag, memberData?.prev_risk_level?.toString(), "", "")}
                />
              </Col>
              {/* </Row>
            <Row> */}
              <Col span={12}>
                <Row>
                  <Col span={10} className="f16" style={{ color: "#5e6c84" }}>
                    <p className={`member-key`} style={{ marginBottom: 24 }}>
                      {isCentric ? "Health Plan" : "Insurance"} <p>End Date</p>
                    </p>
                  </Col>
                  <Col span={14}>
                    {
                      // memberData?.planEndDate === '31-12-9999 00:00:00' ? <span style={{ marginBottom: 24 }} className="f16 w500 clr-n125">
                      // Not Available
                      //   </span> :
                      <p style={{ marginBottom: 24 }}>
                        <span className="f16 w500 clr-n125">{memberData?.planEndDate && memberData?.planEndDate !== "01-01-1900 00:00:00" ? formatDisplayDate(memberData?.planEndDate) : "--"}</span>
                        <span className="f16 clr-e100 w500">
                          {memberData?.planEndDate && memberData?.planEndDate !== "01-01-1900 00:00:00" && (
                            <>
                              {" "}
                              (
                              {moment(memberData?.planEndDate, "DD-MM-YYYY HH:mm:ss").isBefore()
                                ? isCentric
                                  ? "Health Plan Expired"
                                  : "Insurance Expired"
                                : `expiring in ${getDiffFromToday(moment(memberData?.planEndDate, "DD-MM-YYYY HH:mm:ss"), moment(), "ALL")}`}
                              )
                            </>
                          )}
                        </span>
                      </p>
                    }
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={11} className="f16 member-key" style={{ color: "#5e6c84" }}>
                    <p>Assigned PCP Name</p>
                  </Col>
                  <Col span={13}>
                    <div style={{ marginBottom: "5px" }}>
                      <span className="selected-display-date">{memberData?.pcpName && memberData?.pcpName.trim() !== "" ? memberData?.pcpName : "--"}</span>
                    </div>
                    <div>
                      <span>
                        <p className="mail-to-link">
                          <span>
                            <i className="icon icon-call"></i>
                          </span>
                          <span>
                            <a className="mail-to-link__contactNumber" href={`tel: ${memberData?.pcpPhoneNumber}`}>
                              {formatPhoneNumber(memberData?.pcpPhoneNumber, "usFormat")}
                            </a>
                          </span>
                        </p>
                      </span>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <MemberItems
                  left={10}
                  right={14}
                  name="DOB"
                  value={moment(memberData?.memberDob).isValid() ? `${formatDisplayDate(memberData?.memberDob, "createDateFormat", "")} ` : "--"}
                  subValue={evalAge(memberData?.memberDob)}
                />
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={11} className="f16 member-key" style={{ color: "#5e6c84" }}>
                    <p>DOD</p>
                  </Col>
                  <Col span={13}>
                    <UpdateDate
                      memberID={memberData?.memberId}
                      dod={memberData?.date_of_death}
                      atrrKey="member_date_of_death"
                      onChange={(value: any) => {
                        if (value) {
                          setpatientStatus("Deceased");
                        }
                      }}
                    />
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <MemberItems left={10} right={14} containerClass={"patient_status"} rightClass={patientStatus} name="Patient Status" value={patientStatus} />
              </Col>
              <Col span={12}>
                <MemberItems left={11} right={13} name="Assigned Office" value={memberData?.clinicName && memberData?.clinicName.trim() !== "" ? memberData?.clinicName : "--"} />
              </Col>
              {/* </Row>
            <Row> */}
              <Col span={12}>
                <MemberItems left={10} right={14} name="Gender" value={memberData?.memberGender === "M" ? "Male" : memberData?.memberGender === "F" ? "Female" : "--"} />
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={11} className="f16 member-key" style={{ color: "#5e6c84" }}>
                    <p>Attributed PCP</p>
                  </Col>
                  <Col span={13}>
                    <div style={{ marginBottom: "5px" }}>
                      <UpdateTextWithDropdown
                        atrributeName={"attributed_pcp_name"}
                        displayText={memberDetailsAttributedPcpNameLetest}
                        dropDownKeyToFetch={AttributeKeys.PCPNAMELIST}
                        onDisplayTextChange={(text: string) => {
                          setMemberDetailsAttributedPcpNameLetest(text);
                        }}
                        textClassName={`member-value`}
                        onChange={(option: any) => {
                          setattributedPCPPhone(option?.phone || "");
                        }}
                      />
                    </div>
                    {attributedPCPPhone && attributedPCPPhone !== "--" && (
                      <div>
                        <span>
                          <p className="mail-to-link">
                            <span>
                              <i className="icon icon-call"></i>
                            </span>
                            <span>
                              <a className="mail-to-link__contactNumber" href={`tel: ${attributedPCPPhone}`}>
                                {formatPhoneNumber(attributedPCPPhone, "usFormat")}
                              </a>
                            </span>
                          </p>
                        </span>
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
              <Col span={12}>
                <MemberItems left={10} right={14} name="Phone Number" value={formatPhoneNumber(memberData?.memberPhoneNumber, "usFormat")} />
              </Col>
              <Col span={12}>
                <Row>
                  <Col span={11} className="f16 member-key">
                    <p>Attributed Office</p>
                  </Col>
                  <Col span={13}>
                    <UpdateTextWithDropdown
                      atrributeName={"attributed_office_name"}
                      displayText={memberDetailsAttributedOfficeNameLetest}
                      dropDownKeyToFetch={AttributeKeys.OFFICENAMELIST}
                      onDisplayTextChange={(text: string) => {
                        setMemberDetailsAttributedOfficeNameLetest(text);
                      }}
                      textClassName={`member-value`}
                    />
                  </Col>
                </Row>
              </Col>
              {/* </Row>
            <Row> */}
              <Col span={12}>
                <MemberItems
                  left={10}
                  right={14}
                  name="Last Office Visit"
                  value={moment(memberData?.lastOfficeVisit).isValid() ? formatDisplayDate(memberData?.lastOfficeVisit, "createDateFormat", "") : "--"}
                />
              </Col>
              {!isCentric && (
                <Col span={12}>
                  <MemberItems
                    left={11}
                    right={13}
                    name="Previous Primary Username"
                    value={
                      memberData?.previousCareManagerName === null
                        ? "--"
                        : memberData?.attribCareManagerName === memberData?.currentCareManagerName
                        ? memberData?.previousCareManagerName
                        : memberData?.attribCareManagerAssignmentStatus === "N" && memberData?.attribCareManagerName
                        ? memberData?.currentCareManagerName
                        : memberData?.previousCareManagerName
                    }
                  />
                </Col>
              )}
              {isCentric && (
                <>
                  <Col span={12}>
                    <Row>
                      <Col span={10} className="f16 member-key" style={{ color: "#5e6c84" }}>
                        <p>Next Office Visit</p>
                      </Col>
                      <Col span={13}>
                        <UpdateDate memberID={memberData?.memberId} dod={memberData?.nextOfficeVisit} datePickerMode={true} atrrKey="member_next_office_visit_date" />
                      </Col>
                    </Row>
                  </Col>
                  <Col span={12}>
                    <MemberItems left={10} right={14} name="Plan Type" value={memberData?.planType ? memberData?.planType : "--"} />
                  </Col>
                </>
              )}
            </Row>
            {!isCentric && (
              <Row>
                <Col span={12}>
                  <Row>
                    <Col span={10} className="f16 member-key" style={{ color: "#5e6c84" }}>
                      <p>Next Office Visit</p>
                    </Col>
                    <Col span={13}>
                      <UpdateDate memberID={memberData?.memberId} dod={memberData?.nextOfficeVisit} datePickerMode={true} atrrKey="member_next_office_visit_date" />
                    </Col>
                  </Row>
                </Col>

                <Col span={12}>
                  {/* <MemberItems
              left={11}
              right={13}
              name="Current CM"
              value={memberData?.currentCareManagerName && memberData?.currentCareManagerName.trim() !== "" ? memberData?.currentCareManagerName : "--"}
            /> */}
                  <Row>
                    <Col span={11} className="f16 member-key">
                      <p>Current Primary Username</p>
                    </Col>
                    <Col span={13}>
                      <CurrentCM />
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </>
        ) : (
          <DataNotFound message={NO_DATA_FOUND} />
        )}
        {/* </Card> */}
      </Panel>
    </Collapse>
  );
};

const UpdateDate = ({ memberID, dod, datePickerMode = false, atrrKey, onChange }: any) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [selectedDate, setSelectedDate] = useState<string>(dod);
  const [editDisabled, setEditDisabled] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [editDod, setEditDod] = useState<boolean>(false);
  const originalDod = useRef(dod);
  const [setdod] = usePatientProfileStore((state) => [state.setdod]);

  useEffect(() => {
    if (dod === "" || dod === "--") {
      setSelectedDate("--");
      originalDod.current = "--";
    } else {
      setSelectedDate(dod);
      originalDod.current = dod;
    }
  }, [dod, memberID]);

  // On Modal Cancel Click
  const handleCancel = () => {
    setSelectedDate(originalDod.current);
    setModalOpen(false);
  };

  // On Edit Icon Click
  const handleEditClick = () => {
    if (selectedDate === "--" && !datePickerMode) {
      setModalOpen(true);
    } else {
      setEditDod(true);
    }
  };

  // Update state and call update API.
  const handleDatePickerChange = (value: any) => {
    setSelectedDate(moment(value).format(dateFormatConfig.get(getClientName())["defaultDateFormat"]));
    setEditDod(false);
    updateAttribute(atrrKey, moment(value).format(dateFormatConfig.get(getClientName())["defaultDateFormat"]));
  };

  // On Modal ok Click Mark as Inactive
  const handleInactiveClick = () => {
    setLoader(true);
    updateAttribute(atrrKey, selectedDate);
    originalDod.current = selectedDate;
    setdod(originalDod.current);
  };

  const updateAttribute = (attribName: string, value: string) => {
    const cMember = membersService?.getCurrentMember;
    if (cMember && cMember?.patient_id) {
      const patient_id = parseInt(cMember?.patient_id);
      const care_manager_id = parseInt(cMember?.care_manager_id);

      const payLoad = {
        attrib_name: attribName,
        attrib_value: value,
        attri_id_value: value,
        patient_id,
        care_manager_id,
      };

      memberDetailsService.updateSelectedAttribute(payLoad).subscribe({
        next: (response: any) => {
          onChange && onChange(value);
          console.log(response);
          setLoader(false);
          setModalOpen(false);
        },
        error: (error) => {
          console.log(error);
          setLoader(false);
          setModalOpen(false);
        },
      });
    }
  };

  return (
    <>
      {!editDod && (
        <div style={{ display: "flex" }}>
          <Spin spinning={false} indicator={<HealthemSpinner />}>
            <span className="selected-display-date">{selectedDate}</span>
          </Spin>
          <CanEdit>
            <EditOutlined
              className={` ${editDisabled ? "disabled member-details-grey-color" : "member-details-color-for--generic_options"}`}
              onClick={() => {
                handleEditClick();
              }}
            />
          </CanEdit>
        </div>
      )}
      {editDod && (
        <div>
          <Space direction="vertical">
            <DatePicker
              disabled={false}
              value={isEmpty(selectedDate) || selectedDate === "--" ? undefined : moment(moment(selectedDate).format(dateFormatConfig.get(getClientName())["defaultDateFormat"]))}
              format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
              size="middle"
              suffixIcon={<Icon name="calender" />}
              onChange={(value) => {
                handleDatePickerChange(value);
              }}
              disabledDate={(current) => {
                if (atrrKey === "member_next_office_visit_date") {
                  return current && current.valueOf() < Date.now();
                }

                if (atrrKey === "member_date_of_death") {
                  return current && current.valueOf() > Date.now();
                }

                return true;
              }}
              allowClear={false}
              autoFocus
              onBlur={() => {
                setEditDod(false);
              }}
            />
          </Space>
        </div>
      )}

      <Modal
        open={isModalOpen}
        footer={false}
        width={"36%"}
        centered
        onCancel={() => {
          handleCancel();
        }}
      >
        <Spin spinning={loader} indicator={<HealthemSpinner />}>
          <div className="date-modal-container">
            <div style={{ marginBottom: "1rem" }}>
              <p className="date-modal-container--title-line">Do you want to update this patient</p>
              <p className="date-modal-container--title-line">as Deceased?</p>
            </div>

            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginBottom: "1rem" }}>
              <div style={{ marginRight: 15 }}>Date of Death (DOD)</div>
              <div>
                <Space direction="vertical">
                  <DatePicker
                    disabled={false}
                    value={isEmpty(selectedDate) || selectedDate === "--" ? undefined : moment(moment(selectedDate).format(dateFormatConfig.get(getClientName())["defaultDateFormat"]))}
                    format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
                    size="large"
                    suffixIcon={<Icon name="calender" />}
                    onChange={(value) => {
                      console.log("**Changed Date", moment.utc(value).format(dateFormatConfig.get(getClientName())["defaultDateFormat"]));
                      setSelectedDate(moment.utc(value).format(dateFormatConfig.get(getClientName())["defaultDateFormat"]));
                      setEditDod(false);
                    }}
                    disabledDate={(current) => {
                      if (atrrKey === "member_date_of_death") {
                        return current && current.valueOf() > Date.now();
                      }
                      return true;
                    }}
                    allowClear={false}
                  />
                </Space>
              </div>
            </div>

            <div className="date-modal-container--button-container">
              <div>
                <Button
                  className="date-modal-container--button-container__cancel"
                  size="large"
                  onClick={() => {
                    handleCancel();
                  }}
                >
                  Cancel
                </Button>
              </div>
              <div>
                <Button
                  type="primary"
                  className="date-modal-container--button-container__save"
                  size="large"
                  onClick={() => {
                    handleInactiveClick();
                  }}
                >
                  Yes, Mark as Inactive
                </Button>
              </div>
            </div>
          </div>
        </Spin>
      </Modal>
    </>
  );
};

export default withAITracking(reactPlugin, MemberDetails);
